// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__2vpg3","modalForm":"UpgradeEpcsModal_modalForm__1t7Zr","modalFooter":"UpgradeEpcsModal_modalFooter__3SSEt"};